"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var selectable_credit_card_list_container_1 = require("./selectable_credit_card_list_container");
var checkout_billing_address_form_1 = require("./checkout_billing_address_form");
var CheckoutCreditCardSelectionForm = function (props) {
    var billingAddressForm = React.createElement(checkout_billing_address_form_1.default, tslib_1.__assign({}, props));
    return (React.createElement(selectable_credit_card_list_container_1.default, { checkoutBillingAddressForm: billingAddressForm }));
};
exports.default = CheckoutCreditCardSelectionForm;
//# sourceMappingURL=checkout_credit_card_selection_form.js.map


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/dist/credit_cards/checkout_credit_card_selection_form.js
// module id = nTGl
// module chunks = 20 21 22